document.addEventListener("DOMContentLoaded", () => {
  const swiper = new Swiper('.mySwiper1', {
    slidesPerView: 'auto',
    spaceBetween: 20,
    freeMode: true,
    mousewheel: { forceToAxis: true, invert: true },
    keyboard: { enabled: true },
    navigation: {
      nextEl: ".swiper-button-next-ugc",
      prevEl: ".swiper-button-prev-ugc"
    },
    scrollbar: { el: ".swiper-scrollbar-ugc", draggable: true },
    breakpoints: { 1024: {
       slidesPerView: 1.4,
      freeMode: false
    } }
  });

  const slides = document.querySelectorAll('.mySwiper1 .swiper-slide');

  slides.forEach((slide) => {
    const video = slide.querySelector('video');
    const playBtn = slide.querySelector('.play-button-svg');

    // Click to play/pause logic
    slide.addEventListener('click', async (e) => {
      // Pause all other videos
      document.querySelectorAll('.caraousel-video').forEach(v => {
        if (v !== video && !v.paused) {
          v.pause();
          v.muted = true;
          const btn = v.parentElement.querySelector('.play-button-svg');
          if (btn) btn.style.display = 'block';
        }
      });

      if (video.paused) {
        try {
          await new Promise(resolve => setTimeout(resolve, 50)); // small delay
          await video.play();
          video.muted = false;
          playBtn.style.display = 'none';
        } catch (err) {
          console.warn('Playback failed:', err);
        }
      } else {
        video.pause();
        video.muted = true;
        playBtn.style.display = 'block';
      }
    });
  });

  // Auto-pause when out of view
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) {
        const video = entry.target.querySelector('video');
        const playBtn = entry.target.querySelector('.play-button-svg');
        if (video && !video.paused) {
          video.pause();
          video.muted = true;
          if (playBtn) playBtn.style.display = 'block';
        }
      }
    });
  }, {
    threshold: 0.3 // pause if less than 30% in view
  });

  slides.forEach(slide => observer.observe(slide));
});

document.addEventListener("DOMContentLoaded", () => {
  const swipernk = new Swiper('.nhjr-track', {
    slidesPerView: 1.6,
    centeredSlides: true,
    loop : true,
    spaceBetween: 20,
    mousewheel: { forceToAxis: true, invert: true },
    keyboard: { enabled: true },
    navigation: {
      nextEl: ".swiper-button-next-test",
      prevEl: ".swiper-button-prev-test"
    },
    scrollbar: { el: ".swiper-scrollbar-test", draggable: true },
    breakpoints: {
      600: {
        slidesPerView: 1.2,
        centeredSlides: true,
        spaceBetween: 10,
      }
    }
  });
});
